(() => {
  const load = (node) => {
    const source = node.dataset.footerArtwork;
    if (source) { node.style.backgroundImage = `url("${source}")`; delete node.dataset.footerArtwork; }
  };
  const init = (root = document) => {
    const artwork = root.querySelectorAll('[data-footer-artwork]');
    if (!('IntersectionObserver' in window)) { artwork.forEach(load); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); } });
    }, {rootMargin: '400px'});
    artwork.forEach((node) => observer.observe(node));
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
